var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDbRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21967 5.96967C5.51256 5.67678 5.98744 5.67678 6.28033 5.96967L12.2803 11.9697C12.5732 12.2626 12.5732 12.7374 12.2803 13.0303L6.28033 19.0303C5.98744 19.3232 5.51256 19.3232 5.21967 19.0303C4.92678 18.7374 4.92678 18.2626 5.21967 17.9697L10.6893 12.5L5.21967 7.03033C4.92678 6.73744 4.92678 6.26256 5.21967 5.96967ZM13.2197 5.96967C13.5126 5.67678 13.9874 5.67678 14.2803 5.96967L20.2803 11.9697C20.5732 12.2626 20.5732 12.7374 20.2803 13.0303L14.2803 19.0303C13.9874 19.3232 13.5126 19.3232 13.2197 19.0303C12.9268 18.7374 12.9268 18.2626 13.2197 17.9697L18.6893 12.5L13.2197 7.03033C12.9268 6.73744 12.9268 6.26256 13.2197 5.96967Z",
    fill: "url(#paint0_linear_2517_5511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2517_5511",
    x1: 5.01114,
    y1: 12.5,
    x2: 20.5111,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDbRight);
export default __webpack_public_path__ + "static/media/icon_chevron_db_right.e9ef4ea431727f0a568f95dd4d81a516.svg";
export { ForwardRef as ReactComponent };